import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Link from 'Components/Link';
import styles from './UsersListAction.scss';
import EnvelopeIcon from './envelope.svg';
import TrashIcon from './trash-can.svg';
import PencilIcon from './pencil.svg';

class UsersListAction extends React.PureComponent {
  getIcon() {
    switch (this.props.iconType) {
      case 'pencil':
        return (
          <PencilIcon className="UsersListAction__icon UsersListAction__icon--pencil" />
        );
      case 'envelope':
        return (
          <EnvelopeIcon className="UsersListAction__icon UsersListAction__icon--envelope" />
        );
      case 'trash':
        return (
          <TrashIcon className="UsersListAction__icon UsersListAction__icon--trash" />
        );
      default:
        return null;
    }
  }

  render() {
    const { isRequesting, handleClick, to, label, groupType } = this.props;
    const requestClass = isRequesting ? ' is-requesting' : '';
    const className = `UsersListAction${requestClass}`;
    if (to) {
      const linkTo = {
        pathname: to,
        state: {
          groupType,
          backTo: this.props.location.pathname,
        },
      };
      return (
        <Link className={className} to={linkTo}>
          {this.getIcon()}
          {label}
        </Link>
      );
    }
    return (
      <div
        className={className}
        onClick={e => handleClick(e)}
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter') handleClick(e);
        }}
      >
        {this.getIcon()}
        {label}
      </div>
    );
  }
}

UsersListAction.propTypes = {
  isRequesting: PropTypes.bool,
  handleClick: PropTypes.func,
  to: PropTypes.string,
  label: PropTypes.node,
  groupType: PropTypes.oneOf(['class', 'school']),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  iconType: PropTypes.string,
};

export default withRouter(UsersListAction);
